import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { ProductData, ProductResponse } from "../types/product";

const useProduct: (id: string) => UseQueryResult<ProductData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<ProductResponse, unknown, ProductData>({
    queryKey: ['product', id],
    queryFn: () => privateAxios.get(`/products/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useProduct;